/**
 * undefined | null は許容するが、それ以外の場合は ${threshold} 以上の数値であることを検証する
 * @param value
 * @returns
 */
export function nonNegativeNumber({ value, threshold }: { value: number | undefined | null; threshold: number }) {
	if (value === undefined || value === null) {
		return true;
	}

	return value >= threshold;
}

/**
 * undefinedを許容しない
 */
export function requiredValue<T>(value: T | undefined) {
	return value !== undefined;
}
